import { useFt } from 'hooks'

import constants from 'helpers/constants'

import useShippingAddressValidateOld from './useShippingAddressValidateOld'
import useShippingAddressValidateNew from './useShippingAddressValidateNew'


const useShippingAddressValidate = () => {
  const isLoqateAutocompleteValidationEnabled = useFt(constants.features.loqateAutocomplete)

  const validationHook = isLoqateAutocompleteValidationEnabled
    ? useShippingAddressValidateNew
    : useShippingAddressValidateOld

  return validationHook()
}


export default useShippingAddressValidate
